// @flow
export const INTERACTION: 'INTERACTION' = 'INTERACTION';
export const NAVIGATE: 'NAVIGATE' = 'NAVIGATE';
export const REDUX_ACTION: 'REDUX_ACTION' = 'REDUX_ACTION';
export const WHITEBOARD_REDUX_ACTION: 'WHITEBOARD_REDUX_ACTION' =
  'WHITEBOARD_REDUX_ACTION';

export type UserSessionEventBlueprint<T: string, Payload: {}> = $ReadOnly<{|
  type: T,
  payload: Payload,
|}>;

export type InteractionAction = UserSessionEventBlueprint<
  typeof INTERACTION,
  $ReadOnly<{
    interaction: string,
    ...
  }>,
>;

export type Navigate = UserSessionEventBlueprint<
  typeof NAVIGATE,
  $ReadOnly<{|
    to: string,
  |}>,
>;

export type ReduxAction = UserSessionEventBlueprint<typeof REDUX_ACTION, {}>;
export type WhiteboardReduxAction = UserSessionEventBlueprint<
  typeof WHITEBOARD_REDUX_ACTION,
  {},
>;

export type UserEvent =
  | Navigate
  | ReduxAction
  | WhiteboardReduxAction
  | InteractionAction;

export const userSessionEventBuilder = <T: string, Payload: {}>(
  type: T,
  payload: Payload,
): UserSessionEventBlueprint<T, Payload> => ({
  type,
  payload,
});

export const navigateEvent: ($PropertyType<Navigate, 'payload'>) => Navigate = (
  payload,
) => userSessionEventBuilder(NAVIGATE, payload);

export const reduxAction: (
  $PropertyType<ReduxAction, 'payload'>,
) => ReduxAction = (payload) => userSessionEventBuilder(REDUX_ACTION, payload);

export const whiteboardReduxAction: (
  $PropertyType<WhiteboardReduxAction, 'payload'>,
) => WhiteboardReduxAction = (payload) =>
  userSessionEventBuilder(WHITEBOARD_REDUX_ACTION, payload);

export const interactionAction: (
  $PropertyType<InteractionAction, 'payload'>,
) => InteractionAction = (payload) =>
  userSessionEventBuilder(INTERACTION, payload);
